module.exports = __webpack_public_path__ + "static/media/03.3b4b37a3.mp3";